import { render, staticRenderFns } from "./SimTransfer.vue?vue&type=template&id=4f9a0c7e&scoped=true"
import script from "./SimTransfer.vue?vue&type=script&lang=js"
export * from "./SimTransfer.vue?vue&type=script&lang=js"
import style0 from "./SimTransfer.vue?vue&type=style&index=0&id=4f9a0c7e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9a0c7e",
  null
  
)

export default component.exports